import React, { ReactNode } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

function fallbackRender({ error, resetErrorBoundary }: FallbackProps) {
  const errorMessage = error instanceof Error ? error.message : String(error);
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{errorMessage}</pre>
      <button onClick={resetErrorBoundary}>Try Again</button>
    </div>
  );
}

interface CustomErrorBoundaryProps {
  children: ReactNode;
}

const CustomErrorBoundary: React.FC<CustomErrorBoundaryProps> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={fallbackRender}>{children}</ErrorBoundary>;
};

export default CustomErrorBoundary;
